<template>
  <div class="admin-layout" :class="{ 'sidebar-collapsed': collapsed, 'sidebar-open': mobileOpen }">
    <SidebarView :collapsed="collapsed" :open="mobileOpen" @navigate="mobileOpen = false" />
    <div class="sidebar-scrim" @click="mobileOpen = false"></div>

    <div class="admin-main">
      <HeaderView :collapsed="collapsed" @toggle="toggleSidebar" />
      <main id="contenu" class="admin-content" tabindex="-1">
        <router-view v-slot="{ Component, route }">
          <transition name="page-fade" mode="out-in">
            <component :is="Component" :key="route.fullPath" />
          </transition>
        </router-view>
      </main>
    </div>
    <LockScreen v-if="locked" />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import LockScreen from "@/components/ui/LockScreen.vue";
import { useSessionGuard } from "@/composables/useSessionGuard.js";
import HeaderView from "../partials/HeaderView.vue";
import SidebarView from "../partials/SidebarView.vue";

const store = useStore();
/** Application verrouillée : l'écran de verrouillage masque la page (conservée en l'état). */
const locked = computed(() => store.state.auth.locked);
useSessionGuard();

const collapsed = ref(false);
const mobileOpen = ref(false);

const toggleSidebar = () => {
  if (window.matchMedia("(max-width: 991px)").matches) {
    mobileOpen.value = !mobileOpen.value;
  } else {
    collapsed.value = !collapsed.value;
  }
};
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
  background: hsl(var(--muted) / 0.45);
}
.admin-main {
  margin-left: var(--sidebar-width);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.25s ease;
}
.sidebar-collapsed .admin-main {
  margin-left: var(--sidebar-collapsed-width);
}
.admin-content {
  flex: 1;
  padding: 1.5rem;
  outline: none;
  text-align: left;
}
.sidebar-scrim {
  display: none;
}
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.page-fade-enter-from {
  opacity: 0;
  transform: translateY(6px);
}
.page-fade-leave-to {
  opacity: 0;
}
@media (max-width: 991px) {
  .admin-main,
  .sidebar-collapsed .admin-main {
    margin-left: 0;
  }
  .admin-content {
    padding: 1rem;
  }
  .sidebar-open .sidebar-scrim {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 1040;
    background: rgb(15 23 42 / 0.4);
  }
}
</style>
